// extracted by mini-css-extract-plugin
export default {"burger_menu":"BurgerMenu_burger_menu__EWA7c","burger_b":"BurgerMenu_burger_b__MZ-V0"};